import React, { Component } from "react";
import "./About.css";

class AboutUs extends Component {
  render() {
    return (
      <div className="about_container">
        <h1 className="about_section_header">O našoj stranici</h1>
        <p className="about_section_header">Uskoro...</p>
      </div>
    );
  }
}

export default AboutUs;
